import { IonCol, IonGrid, IonIcon, IonRow, IonText } from "@ionic/react";
import {
  checkmarkSharp,
  chevronForwardOutline,
  closeSharp,
  helpSharp,
} from "ionicons/icons";
import { useEffect, useState } from "react";
import {
  makeGETRequest,
  makePATCHRequest,
  makePOSTRequest,
} from "../../request/rawRequest";
import { getCurrentTechnoOrDisconnect } from "../../variables/jobDictionnary";
import BasicPage from "../BasicPage/BasicPage";
import PDFViewer from "../Book/Viewer";
import "../IonColor/color.css";
import Reader from "./Reader";
import Synthesis from "./Synthesis/Synthesis";
import "./Video.css";
import { VideoList } from "./components/VideoList";

interface ContainerProps {}

function isPdfLink(link: string): boolean {
  // Vérifie si le lien se termine par ".pdf" (insensible à la casse)
  console.log("test:", link.trim().toLowerCase().endsWith(".pdf"));
  return link.trim().toLowerCase().endsWith(".pdf");
}

const setVideoViewed = async (id: any): Promise<any> => {
  await makePATCHRequest("/video/viewed?id_video=" + id);
};

export type QuizzBack = {
  awnser: Array<string>;
  question: string;
  valide: Array<string>;
};

export type VideoBackType = {
  _id: string;
  name: string;
  link: string;
  links?: {
    link: string;
    pictureUrl: string;
    name: string;
  }[];
  viewed: boolean;
  quizz: Array<QuizzBack>;
  synthesis: any;
  pages: number[];
  fileUrl?: string;
};

const defaultType: VideoBackType = {
  _id: "",
  name: "",
  link: "",
  viewed: false,
  quizz: [],
  synthesis: {},
  pages: [],
  links: [],
};

const getTheme = async (idComp: string): Promise<string> => {
  let themes: string[] = [];
  let themesRes: any[] = [];
  themes.push(idComp);

  await makePOSTRequest("/themes", { _id: themes }).then((response) => {
    themesRes = response;
  });
  return themesRes[0].id_videos[0];
};

const getCompetence = async (compID: string): Promise<String[]> => {
  const competences: String[] = [];

  await makeGETRequest(
    "/skills/technology/unique?type=" +
      getCurrentTechnoOrDisconnect() +
      "&pole=" +
      localStorage.getItem("pole"),
  ).then(async (res) => {
    res.map((s: any, i: number) => {
      if (s._id === compID) competences.push(...s.id_themes);
    });
  });

  return competences;
};

const getScoreSentence = (score: number) => {
  if (score <= 10) return "C'est insufisant, continue à travailler !";
  if (score <= 14) return "Ton travail est convenable, encore un effort !";
  return "Tu maîtrises cet aspect, bravo !";
};

const VideoDisplay: React.FC<ContainerProps> = () => {
  const [videoEnd, setVideoEnded] = useState<boolean>(false);
  const [showAnswers, setShowAnswers] = useState<boolean>(false);
  const [currentQuestion, setCurrentQuestion] = useState<number>(0);
  const [score, setScore] = useState<number>(0);
  const [videoAvailable, setVideoAvailable] = useState<boolean>(true);
  const [video, setvideo] = useState<VideoBackType>(defaultType);
  const [result, setResult] = useState<number[][]>([]);
  const urlParams = new URLSearchParams(window.location.search);
  const [newHref, setNewHref] = useState<string>("");
  const [bookLoader, setBookLoader] = useState<boolean>(true);

  let videoList: VideoBackType = defaultType;

  const studentSpecialty = localStorage.getItem("techno") ?? "";

  const getNewHref = () => {
    const newHrefReq = new URLSearchParams();
    const urlParams = new URLSearchParams(window.location.search);

    const compID = urlParams.get("compID") ?? "";
    const theme = urlParams.get("theme") ?? "";
    const videoActualID = urlParams.get("id") ?? "";
    let nextTheme = "";
    let nextVideo = "";

    //req to get comp
    const comp = getCompetence(compID);
    comp.then(async (res) => {
      //find the next theme if has one
      res.sort();

      const vids: { name: string; _id: string; index: number }[] = [];

      for (const _id of res) {
        await makePOSTRequest("/themes", { _id })
          .then((res) => {
            return res[0];
          })
          .then(async (resT) => {
            await makePOSTRequest("/videos", { _id: resT.id_videos[0] ?? "" })
              .then((resV) => resV[0])
              .then((resV) => {
                vids.push({
                  name: resV.name,
                  _id: resV._id,
                  index: resV.index,
                });
              });
          });
      }

      vids.sort((a, b) => a?.index - b?.index);

      const nextVideoIndex = vids.findIndex((a) => a._id === videoActualID) + 1;

      const nextVideo = vids[nextVideoIndex];

      if (nextVideo) {
        newHrefReq.append("theme", nextTheme);
        newHrefReq.append("id", nextVideo._id);
        newHrefReq.append("compID", compID);
        setNewHref(newHrefReq.toString());
      }
    });
  };

  const isCharOrPrim =
    localStorage.getItem("techno") === "char" ||
    localStorage.getItem("techno") === "prim";

  const onHitLastPage = () => {
    if (isCharOrPrim) {
      setVideoEnded(true);
      setVideoViewed(urlParams.get("id"));
    }
  };
  const fetchVideo = async () => {
    await makePOSTRequest("/videos", { _id: urlParams.get("id") }).then(
      (data) => {
        const test: VideoBackType = {
          _id: data[0]._id,
          name: data[0].name,
          link: data[0].link,
          viewed: data[0].viewed,
          quizz: data[0].quizz,
          synthesis: data[0].synthesis,
          pages: data[0].pages,
          fileUrl: data[0].fileUrl,
          links: data[0].links,
        };
        videoList = test;
        if (videoList.link === undefined) {
          setVideoAvailable(false);
        }
        setvideo(videoList);
        setResult((old) => {
          old = [];
          for (let i = 0; i < test.quizz.length; i++) {
            old.push([]);
          }
          return old;
        });
      },
    );
  };

  useEffect(() => {
    if (showAnswers) {
      makePOSTRequest("/mark", {
        id_thing: urlParams.get("id"),
        mark: score,
        type: "quizz",
      }).catch((e) => {
        console.error("error", e);
      });
    }
  }, [showAnswers]);

  useEffect(() => {
    let scoreSum = 0;
    let scoreFinal = 0;
    let totalAwnsers = 0;

    result.map((q, i) => {
      scoreFinal = 0;
      totalAwnsers += video.quizz[i].valide.length;
      q.map((r) => {
        if (video.quizz[i].valide.includes(r.toString())) scoreFinal += 1;
        else scoreFinal -= 0.2;
      });
      if (scoreFinal < 0) scoreFinal = 0;
      scoreFinal = Math.round((scoreFinal + Number.EPSILON) * 100) / 100;
      scoreSum += scoreFinal;
    });
    scoreSum = (scoreSum / totalAwnsers) * 20;
    scoreSum = Math.round((scoreSum + Number.EPSILON) * 100) / 100;
    setScore(scoreSum);
  }, [result]);

  useEffect(() => {
    if (video._id === "") {
      fetchVideo();
    }
    setVideoEnded(video.viewed);
  }, [video]);

  useEffect(() => {
    getNewHref();
  }, []);

  return (
    <BasicPage pathReturn title={video.name}>
      {!["char"].includes(studentSpecialty) &&
      !["prim"].includes(studentSpecialty) &&
      !["cuis"].includes(studentSpecialty) ? (
        <>
          {video.link !== undefined ? (
            <IonRow>
              <IonCol>
                {titleSection(1 + ") Le cours en vidéo")}

                <video
                  autoPlay={false}
                  controls={true}
                  onContextMenu={(e) => {
                    e.preventDefault();
                  }}
                  onEnded={() => {
                    setVideoEnded(true);
                    setVideoViewed(video._id);
                  }}
                  controlsList="nodownload"
                  className="video"
                  src={video.link}
                >
                  <source src={video.link} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {video.links && video.links.length > 0 && (
                  <VideoList
                    onVideoEnded={() => {}}
                    videos={video.links.map((v, index) => ({
                      _id: index.toString(),
                      isViewed: false,
                      link: v.link,
                      name: v.name,
                      pictureUrl: v.pictureUrl,
                    }))}
                  />
                )}
              </IonCol>
            </IonRow>
          ) : null}

          <IonRow className="ion-justify-content-left">
            {titleSection("2) Quizz : teste tes connaissances")}
          </IonRow>
          {video.quizz && videoEnd ? (
            <IonRow>
              <IonGrid hidden={showAnswers}>
                <IonRow>
                  <IonCol size="12" size-lg="12" size-sm="12">
                    {video.quizz &&
                    video.quizz.length > 0 &&
                    video.quizz[currentQuestion] ? (
                      <p className="black-text bold center-align-text">
                        {currentQuestion + 1}/{video.quizz.length}{" "}
                        {video.quizz[currentQuestion].question}
                      </p>
                    ) : (
                      <p className="black-text bold center-align-text">
                        Aucune question disponible
                      </p>
                    )}
                  </IonCol>
                </IonRow>
                {video.quizz &&
                video.quizz.length > 0 &&
                video.quizz[currentQuestion] &&
                video.quizz[currentQuestion].awnser
                  ? video.quizz[currentQuestion].awnser.map((a, i) => {
                      return (
                        <IonRow key={i} className="anwser">
                          <IonCol
                            size-lg="12"
                            size="12"
                            size-sm="12"
                            className="btn btn-resp no-bold no-padding"
                          >
                            <IonRow>
                              <IonCol
                                size="1"
                                className="ion-justify-content-center flex ion-align-items-center"
                              >
                                <input
                                  className="quizz-checkbox fullHeight fullWidth"
                                  type={"checkbox"}
                                  id={"anwser" + i}
                                  checked={result[currentQuestion]?.includes(i)}
                                  onChange={() => {
                                    if (!result[currentQuestion].includes(i)) {
                                      setResult((old) => [
                                        ...old.slice(0, currentQuestion),
                                        [...old[currentQuestion], i],
                                        ...old.slice(
                                          currentQuestion + 1,
                                          old.length,
                                        ),
                                      ]);
                                    } else {
                                      setResult((old) => [
                                        ...old.slice(0, currentQuestion),
                                        [
                                          ...old[currentQuestion].filter(
                                            (v) => v !== i,
                                          ),
                                        ],
                                        ...old.slice(
                                          currentQuestion + 1,
                                          old.length,
                                        ),
                                      ]);
                                    }
                                  }}
                                ></input>
                              </IonCol>
                              <IonCol size="11" className="no-padding">
                                <label
                                  className="fullWidth fullHeight flex ion-align-items-center ion-justify-content-center input-padding"
                                  htmlFor={"anwser" + i}
                                >
                                  {a}
                                </label>
                              </IonCol>
                            </IonRow>
                          </IonCol>
                        </IonRow>
                      );
                    })
                  : null}
                <IonRow
                  hidden={showAnswers}
                  onClick={() => {
                    if (currentQuestion !== video.quizz.length - 1)
                      setCurrentQuestion((old) => old + 1);
                    else setShowAnswers(true);
                  }}
                  className=" flex ion-justify-content-end"
                >
                  <IonCol
                    size="6"
                    sizeLg="6"
                    sizeXs="6"
                    className="bold btn btn-shade"
                  >
                    {currentQuestion === video.quizz.length - 1 ? (
                      "Voir les résultats"
                    ) : (
                      <div className="flex ion-align-items-center ion-justify-content-center">
                        Question Suivante
                        <IonIcon
                          icon={chevronForwardOutline}
                          size="large"
                        ></IonIcon>
                      </div>
                    )}
                  </IonCol>
                </IonRow>
              </IonGrid>
              <IonGrid hidden={!showAnswers}>
                <p className="black-text">
                  Ta note pour ce quizz est de : {score}/20.
                  {getScoreSentence(score)}
                </p>
                <p className="black-text">Résumé de tes réponses</p>
                {video.quizz.map((q, i) => {
                  return (
                    <IonGrid key={i} className="white-bg second-border margin">
                      <IonRow>
                        <IonCol className="black-text bold">
                          {q.question}
                        </IonCol>
                      </IonRow>
                      {q.awnser.map((a, j) => {
                        if (!result[i] || !result[i].includes(j)) return;
                        return (
                          <IonRow key={j}>
                            <IonCol
                              size="1"
                              className="flex ion-align-items-center ion-justify-content-center"
                            >
                              {q.valide.includes(j.toString()) &&
                              result[i].includes(j) ? (
                                <IonIcon
                                  icon={checkmarkSharp}
                                  className="green"
                                ></IonIcon>
                              ) : !q.valide.includes(j.toString()) &&
                                result[i].includes(j) ? (
                                <IonIcon
                                  icon={closeSharp}
                                  className="red"
                                ></IonIcon>
                              ) : (
                                ""
                              )}
                            </IonCol>
                            <IonCol size="10" className="black-text">
                              {a}
                            </IonCol>
                          </IonRow>
                        );
                      })}
                      {result[i]?.length < q.valide.length ? (
                        <IonRow>
                          <IonCol
                            size="1"
                            className="flex ion-align-items-center ion-justify-content-center"
                          >
                            <IonIcon
                              icon={helpSharp}
                              className="black-text"
                            ></IonIcon>
                          </IonCol>
                          <IonCol size="10" className="black-text">
                            Il te manque une ou plusieurs réponses
                          </IonCol>
                        </IonRow>
                      ) : (
                        ""
                      )}
                    </IonGrid>
                  );
                })}
              </IonGrid>
            </IonRow>
          ) : (
            <IonRow>
              <IonCol>
                <IonText color="black">
                  <h5>Regarde la vidéo jusqu'à la fin pour avoir le quizz</h5>
                </IonText>
              </IonCol>
            </IonRow>
          )}
          <IonRow className="ion-justify-content-left">
            {titleSection("3) Ressources de technologie")}
          </IonRow>
          <IonRow className="ion-justify-content-start ion-align-items-center">
            <IonCol size-lg="12" size-sm="12" size="12">
              <IonRow>
                <IonCol>
                  <IonText color="black">
                    <h3 className="no-margin">Approfondis tes connaissances</h3>
                  </IonText>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol>
                  {video && video.pages ? (
                    <Reader
                      title={video.name}
                      name="Lis ta leçon"
                      pages={video.pages}
                    />
                  ) : (
                    <IonRow>
                      <IonCol size-lg="8" size-sm="8">
                        <p
                          className="bold hover-underline fullWidth btn disabled-bg no-margin"
                          id="disabled"
                        >
                          Lire
                        </p>
                      </IonCol>
                    </IonRow>
                  )}
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>
          {video ? (
            <>
              <IonRow className="ion-justify-content-left">
                {titleSection("4) La synthèse")}
              </IonRow>
              <IonRow>
                <IonCol>
                  <IonRow>
                    <IonCol>
                      <IonText color="black">
                        <h3 style={{ textAlign: "center" }}>
                          Applique tes connaissances
                        </h3>
                      </IonText>
                    </IonCol>
                  </IonRow>
                  <IonRow className="ion-justify-content-center">
                    <IonCol
                      size="12"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      {video &&
                      video.synthesis &&
                      video.synthesis.link &&
                      video.synthesis.words ? (
                        <Synthesis
                          label="Exerce-toi"
                          data={video.synthesis}
                          idVideo={video._id}
                        />
                      ) : (
                        <IonRow className="ion-justify-content-center">
                          <IonCol size-lg="5" size-sm="5">
                            <p
                              className="bold hover-underline response-button disabled-bg"
                              id="disabled"
                            >
                              Exerce toi
                            </p>
                          </IonCol>
                        </IonRow>
                      )}
                    </IonCol>
                  </IonRow>
                </IonCol>
              </IonRow>
            </>
          ) : null}
          <IonRow className="ion-justify-content-center">
            <IonCol
              size-lg="7"
              size-sm="7"
              onClick={() => {
                window.location.href = "auth/pole/video?" + newHref;
              }}
              id={newHref.length > 0 ? "" : "disabled"}
            >
              <p
                className={
                  "bold hover-underline btn btn-shade   " +
                  (newHref.length > 0 ? "" : "disabled-bg")
                }
              >
                Thème suivant
              </p>
            </IonCol>
          </IonRow>
        </>
      ) : (
        <>
          {video.link !== undefined &&
          video.link.length > 0 &&
          !isPdfLink(video.link) ? (
            <IonRow>
              <IonCol>
                {titleSection(1 + ") Le cours en vidéo")}

                <video
                  autoPlay={false}
                  controls={true}
                  onContextMenu={(e) => {
                    e.preventDefault();
                  }}
                  onEnded={() => {
                    setVideoEnded(true);
                    setVideoViewed(video._id);
                  }}
                  controlsList="nodownload"
                  className="video"
                  src={video.link}
                >
                  <source src={video.link} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </IonCol>
            </IonRow>
          ) : (
            <>
              {video.link !== undefined &&
              video.link.length > 0 &&
              isPdfLink(video.link) &&
              localStorage.getItem("techno") !== "cuis" ? (
                <IonRow className="ion-justify-content-center">
                  <IonCol size="12" className="ion-no-padding">
                    {titleSection("1) Le cours à lire")}
                    <div className="pdf-container ion-no-padding">
                      <PDFViewer
                        isItBook={true}
                        fileURL={video.link}
                        setBookLoader={(isLoad: any) => setBookLoader(isLoad)}
                      />
                    </div>
                  </IonCol>
                </IonRow>
              ) : (
                <>
                  {localStorage.getItem("techno") !== "prim" ? (
                    <>
                      {titleSection("1) Le cours à lire")}
                      <Reader
                        url={video.link}
                        title={video.name}
                        name="Lis ta leçon"
                        pages={video.pages}
                      />
                    </>
                  ) : null}
                </>
              )}
            </>
          )}

          {video.links && video.links.length > 0 && (
            <VideoList
              onVideoEnded={() => {}}
              videos={video.links.map((v, index) => ({
                _id: index.toString(),
                isViewed: false,
                link: v.link,
                name: v.name,
                pictureUrl: v.pictureUrl,
              }))}
            />
          )}

          {video.fileUrl !== undefined &&
          localStorage.getItem("techno") != "cuis" ? (
            <>
              <IonRow className="ion-justify-content-left">
                {video.link !== undefined && video.link.length > 0
                  ? titleSection("2) Ressources de technologie")
                  : titleSection("1) Ressources de technologie")}
              </IonRow>
              <IonRow className="ion-justify-content-start ion-align-items-center">
                <IonCol size-lg="12" size-sm="12" size="12">
                  <IonRow>
                    <IonCol>
                      <IonText color="black">
                        <h3 className="no-margin">
                          Approfondis tes connaissances
                        </h3>
                      </IonText>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol>
                      {video && video.pages ? (
                        <Reader
                          url={video.fileUrl}
                          title={video.name}
                          name="Lis ta leçon"
                          pages={video.pages}
                          onHitLastPage={onHitLastPage}
                        />
                      ) : (
                        <IonRow>
                          <IonCol size-lg="8" size-sm="8">
                            <p
                              className="bold hover-underline fullWidth btn disabled-bg no-margin"
                              id="disabled"
                            >
                              Lire
                            </p>
                          </IonCol>
                        </IonRow>
                      )}
                    </IonCol>
                  </IonRow>
                </IonCol>
              </IonRow>
            </>
          ) : null}

          {/* //QUIZZ */}
          <IonRow className="ion-justify-content-left">
            {titleSection("2) Quizz : teste tes connaissances")}
          </IonRow>
          {video.quizz && videoEnd ? (
            <IonRow>
              <IonGrid hidden={showAnswers}>
                <IonRow>
                  <IonCol size="12" size-lg="12" size-sm="12">
                    {video.quizz &&
                    video.quizz.length > 0 &&
                    video.quizz[currentQuestion] ? (
                      <p className="black-text bold center-align-text">
                        {currentQuestion + 1}/{video.quizz.length}{" "}
                        {video.quizz[currentQuestion].question}
                      </p>
                    ) : (
                      <p className="black-text bold center-align-text">
                        Aucune question disponible
                      </p>
                    )}
                  </IonCol>
                </IonRow>
                {video.quizz &&
                video.quizz.length > 0 &&
                video.quizz[currentQuestion] &&
                video.quizz[currentQuestion].awnser ? (
                  video.quizz[currentQuestion].awnser.map((a, i) => {
                    return (
                      <IonRow key={i} className="anwser">
                        <IonCol
                          size-lg="12"
                          size="12"
                          size-sm="12"
                          className="btn btn-resp no-bold no-padding"
                        >
                          <IonRow>
                            <IonCol
                              size="1"
                              className="ion-justify-content-center flex ion-align-items-center"
                            >
                              <input
                                className="quizz-checkbox fullHeight fullWidth"
                                type={"checkbox"}
                                id={"anwser" + i}
                                checked={result[currentQuestion]?.includes(i)}
                                onChange={() => {
                                  if (!result[currentQuestion].includes(i)) {
                                    setResult((old) => [
                                      ...old.slice(0, currentQuestion),
                                      [...old[currentQuestion], i],
                                      ...old.slice(
                                        currentQuestion + 1,
                                        old.length,
                                      ),
                                    ]);
                                  } else {
                                    setResult((old) => [
                                      ...old.slice(0, currentQuestion),
                                      [
                                        ...old[currentQuestion].filter(
                                          (v) => v !== i,
                                        ),
                                      ],
                                      ...old.slice(
                                        currentQuestion + 1,
                                        old.length,
                                      ),
                                    ]);
                                  }
                                }}
                              ></input>
                            </IonCol>
                            <IonCol size="11" className="no-padding">
                              <label
                                className="fullWidth fullHeight flex ion-align-items-center ion-justify-content-center input-padding"
                                htmlFor={"anwser" + i}
                              >
                                {a}
                              </label>
                            </IonCol>
                          </IonRow>
                        </IonCol>
                      </IonRow>
                    );
                  })
                ) : (
                  <> </>
                )}
                <IonRow
                  hidden={showAnswers}
                  onClick={() => {
                    if (currentQuestion !== video.quizz.length - 1)
                      setCurrentQuestion((old) => old + 1);
                    else setShowAnswers(true);
                  }}
                  className=" flex ion-justify-content-end"
                >
                  <IonCol
                    size="6"
                    sizeLg="6"
                    sizeXs="6"
                    className="bold btn btn-shade"
                  >
                    {currentQuestion === video.quizz.length - 1 ? (
                      "Voir les résultats"
                    ) : (
                      <div className="flex ion-align-items-center ion-justify-content-center">
                        Question Suivante
                        <IonIcon
                          icon={chevronForwardOutline}
                          size="large"
                        ></IonIcon>
                      </div>
                    )}
                  </IonCol>
                </IonRow>
              </IonGrid>
              <IonGrid hidden={!showAnswers}>
                <p className="black-text">
                  Ta note pour ce quizz est de : {score}/20.
                  {getScoreSentence(score)}
                </p>
                <p className="black-text">Résumé de tes réponses</p>
                {video.quizz.map((q, i) => {
                  return (
                    <IonGrid key={i} className="white-bg second-border margin">
                      <IonRow>
                        <IonCol className="black-text bold">
                          {q.question}
                        </IonCol>
                      </IonRow>
                      {q.awnser.map((a, j) => {
                        if (!result[i].includes(j)) return;
                        return (
                          <IonRow key={j}>
                            <IonCol
                              size="1"
                              className="flex ion-align-items-center ion-justify-content-center"
                            >
                              {q.valide.includes(j.toString()) &&
                              result[i].includes(j) ? (
                                <IonIcon
                                  icon={checkmarkSharp}
                                  className="green"
                                ></IonIcon>
                              ) : !q.valide.includes(j.toString()) &&
                                result[i].includes(j) ? (
                                <IonIcon
                                  icon={closeSharp}
                                  className="red"
                                ></IonIcon>
                              ) : (
                                ""
                              )}
                            </IonCol>
                            <IonCol size="10" className="black-text">
                              {a}
                            </IonCol>
                          </IonRow>
                        );
                      })}
                      {result[i].length < q.valide.length ? (
                        <IonRow>
                          <IonCol
                            size="1"
                            className="flex ion-align-items-center ion-justify-content-center"
                          >
                            <IonIcon
                              icon={helpSharp}
                              className="black-text"
                            ></IonIcon>
                          </IonCol>
                          <IonCol size="10" className="black-text">
                            Il te manque une ou plusieurs réponses
                          </IonCol>
                        </IonRow>
                      ) : (
                        ""
                      )}
                    </IonGrid>
                  );
                })}
              </IonGrid>
            </IonRow>
          ) : (
            <IonRow>
              <IonCol>
                <IonText color="black">
                  <h5>Lis ton cours pour avoir accès au quizz</h5>
                </IonText>
              </IonCol>
            </IonRow>
          )}

          {/* //BOUTTON SUIVANT */}

          <IonRow className="ion-justify-content-center">
            <IonCol
              size-lg="7"
              size-sm="7"
              onClick={() => {
                window.location.href = "auth/pole/video?" + newHref;
              }}
              id={newHref.length > 0 ? "" : "disabled"}
            >
              <p
                className={
                  "bold hover-underline btn btn-shade   " +
                  (newHref.length > 0 ? "" : "disabled-bg")
                }
              >
                Thème suivant
              </p>
            </IonCol>
          </IonRow>
        </>
      )}
    </BasicPage>
  );
};

export default VideoDisplay;

export const titleSection = (title: string) => {
  return (
    <IonText style={{ color: "var(--ion-color-primary-contrast)" }}>
      <h3>{title}</h3>
    </IonText>
  );
};
